import { render, staticRenderFns } from "./ClassAskTeacherAction.vue?vue&type=template&id=5cacccac&scoped=true&"
import script from "./ClassAskTeacherAction.vue?vue&type=script&lang=js&"
export * from "./ClassAskTeacherAction.vue?vue&type=script&lang=js&"
import style0 from "./ClassAskTeacherAction.vue?vue&type=style&index=0&id=5cacccac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cacccac",
  null
  
)

export default component.exports